import { memo } from 'react'
import { Image } from '@dustin-web/microsite-components/src/image/image'

type Props = {
  index: number
  imageUrl: string
  width: number
  height: number
} & React.HTMLAttributes<HTMLDivElement>

const CarouselSlide = ({ index, imageUrl, width, height, onClick }: Props) => (
  <Image
    data-testid={`carousel-slide-${index}`}
    alt={`Product image slide ${index + 1}`}
    onClick={onClick}
    priority={index === 0}
    src={imageUrl}
    width={width}
    height={height}
  />
)

export default memo(CarouselSlide)
